/**
 * Contributor DACI contacts may be marked non-editable by the API (`cannotEdit`).
 * Those rows must not be removable from DACI contact chips / staged deletions.
 */
export function isContributorContactRemovalLocked(
  contact: { daciRole?: string; cannotEdit?: boolean },
  contextDaciRole?: string
): boolean {
  const role = contextDaciRole ?? contact.daciRole;
  return role === 'Contributor' && contact.cannotEdit === true;
}
